export enum EnumPersistentModalKey {
  ACCOUNT_PAGE_UPSELL = 'ACCOUNT_PAGE_UPSELL',
  ACTIVATE_TOKAMAK_CARD = 'ACTIVATE_TOKAMAK_CARD',
}
